const RANDOM_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

function randomString(length: number): string {
  let out = '';
  for (let i = 0; i < length; i++) {
    out += RANDOM_CHARS[Math.floor(Math.random() * RANDOM_CHARS.length)];
  }
  return out;
}

function formatDate(format: string, date: Date): string {
  const pad = (n: number, w = 2) => n.toString().padStart(w, '0');
  return format
    .replace(/yyyy/g, date.getFullYear().toString())
    .replace(/yy/g, pad(date.getFullYear() % 100))
    .replace(/MM/g, pad(date.getMonth() + 1))
    .replace(/dd/g, pad(date.getDate()))
    .replace(/HH/g, pad(date.getHours()))
    .replace(/mm/g, pad(date.getMinutes()))
    .replace(/ss/g, pad(date.getSeconds()));
}

export function previewIdentity(template: string, seed: number): string {
  if (!template) return '';
  const today = new Date();
  let out = template;
  out = out.replace(/\{ID\}/g, (seed + 1).toString());
  out = out.replace(/\{RANDOM\[(\d+)\]\}/g, (_m, n) => randomString(parseInt(n, 10)));
  out = out.replace(
    /\{(PICKUPDATE|INVOICEDATE|CREATEDATE|CREATEDDATE|QUOTEDATE|LOADBOARDDATE)(?::([^}]+))?\}/g,
    (_m, _name, fmt) => formatDate(fmt || 'yyyyMMdd', today)
  );
  return out;
}
